import React from "react";
import ReactDOM from "react-dom/client";

import { ConfigProvider, App as AppComponent } from "antd";
import jaJP from "antd/locale/ja_JP";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import moment from "moment";
import "moment/dist/locale/ja";
import "./index.css";
import "./config/timezone";

import App from "./App";

moment.locale("ja");

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
		},
	},
});

const removeLoader = () => {
	const loader = document.getElementById("globalLoader");
	if (loader) {
		loader.style.opacity = 0;
		loader.parentNode.removeChild(loader);
	}
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	// <React.StrictMode>
	<QueryClientProvider client={queryClient}>
		<ConfigProvider
			locale={jaJP}
			theme={{
				token: {
					colorPrimary: "#99CA29",
					borderRadius: 4,
					colorText: "rgba(0, 0, 0, 0.6)",
				},
				components: {
					Form: {
						labelColor: "#262626",
					},
				},
			}}
			button={{
				autoInsertSpace: false,
			}}
		>
			<AppComponent>
				<HelmetProvider>
					{import.meta.env.VITE_APP_ENV !== "PRODUCTION" ? (
						<Helmet>
							<meta name="robots" content="noindex, nofollow" />
						</Helmet>
					) : null}
					<App />
				</HelmetProvider>
			</AppComponent>
		</ConfigProvider>
	</QueryClientProvider>,
	// </React.StrictMode>
);

removeLoader();
